export default __webpack_public_path__ + "static/form-grouping-dont-656c0235267cf45f31d238e7d87212ffe052681dd3454a0382f3ed58cae3829c.png";